import { getDateDescription } from './getScheduleDescription.js';
import { getWorkScheduleWeek } from './getWorkScheduleWeek.js';
export const renderWorkSchedule = (workSchedule) => {
    const workScheduleWeek = getWorkScheduleWeek(workSchedule);
    const timeOfWork = workSchedule ? getDateDescription(workScheduleWeek) : '';
    const businessTimeOfWork = workSchedule ? workSchedule.businessScheduleDescription : '';
    if (!workSchedule) {
        return null;
    }
    if (!workSchedule.businessScheduleVisibleTag) {
        return renderMatchingTimeOfWork(timeOfWork);
    }
    if (workSchedule.businessScheduleVisibleTag &&
        workSchedule.businessScheduleDescription === null) {
        return renderIndividualTimeOfWork(timeOfWork);
    }
    return renderDefaultTimeOfWork(timeOfWork, businessTimeOfWork);
};
const renderIndividualTimeOfWork = (timeOfWork) => `<p><b>Режим обслуживания физ.лиц:<br/></b>${timeOfWork}</p>`;
const renderMatchingTimeOfWork = (timeOfWork) => `<p><b>Режим обслуживания физ. и юр. лиц:<br/></b> ${timeOfWork}</p>`;
const renderDefaultTimeOfWork = (timeOfWork, businessTimeOfWork) => `<p><b>Режим обслуживания физ.лиц:<br/></b>${timeOfWork}</p> <p><b>Режим обслуживания юр.лиц:<br/></b>${businessTimeOfWork}</p>`;
//# sourceMappingURL=renderWorkSchedule.js.map